import type { TOC } from '@ember/component/template-only';
import {
  PrismButton,
  PrismMessage,
  PrismModal,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

import styles from './not-found-profile.module.css';

interface SettingsCurrencyConversionModalsNotFoundProfileSignature {
  Args: {
    onClose: () => void;
  };
}

<template>
  <PrismModal @onClose={{@onClose}} class={{styles.info-modal}}>
    <:default>
      <PrismMessage
        @description={{t
          "settings.currency_conversion.modals.not_found_profile.description"
        }}
        @illustration="100x100_binoculars"
        @title={{t
          "settings.currency_conversion.modals.not_found_profile.title"
        }}
      >
        <:secondaryAction>
          <PrismButton
            @buttonType="primary"
            @label={{t
              "settings.currency_conversion.modals.not_found_profile.cta"
            }}
            @onClick={{@onClose}}
          />
        </:secondaryAction>
      </PrismMessage>
    </:default>
  </PrismModal>
</template> satisfies TOC<SettingsCurrencyConversionModalsNotFoundProfileSignature>;
